import React, { useState, useCallback, useEffect } from 'react';
import { usePilotsValue } from '@bingads-webui-campaign-react/basic-context-utils';
import { dispatchStructuredLogUserEngagementEvent } from '@bingads-webui-react/copilot-logger';

import { AdsCopilotLoader } from './ads-copilot-loader';

export const AdsCopilotRenderer = React.memo((props) => {
  const isPMaxLiteCopilotLiveAgentEnabled = usePilotsValue('IsPMaxLiteCopilotLiveAgentEnabled');

  // Controls visibility of the Copilot UI
  const [showCopilot, setShowCopilot] = useState(false);

  // Controls initialization/mounting of the Copilot component
  const [enableCopilot, setEnableCopilot] = useState(false);

  // Used to force remounting the Copilot live agent component
  const [key, setKey] = useState(0);

  const handleCopilotToggle = useCallback((e) => {
    if (e.detail.eventData.ActionId === 'liveAgentSupport') {
      setShowCopilot(true);
      setEnableCopilot(true);

      dispatchStructuredLogUserEngagementEvent({
        activity: {},
        options: {
          chatTriggerSource: { source: 'pmaxSignupLiveAgent' },
        },
      });
    }
  }, []);

  useEffect(() => {
    document.addEventListener('copilotToggleEvent', handleCopilotToggle);
    return () => {
      document.removeEventListener('copilotToggleEvent', handleCopilotToggle);
    };
  }, [handleCopilotToggle]);

  const restartLiveAgentConversation = useCallback(() => {
    setKey(prevKey => prevKey + 1);
  }, []);

  const onClose = useCallback((captchaVerified) => {
    setShowCopilot(false);
    if (!captchaVerified) {
      restartLiveAgentConversation();
    }
  }, [restartLiveAgentConversation]);

  if (!isPMaxLiteCopilotLiveAgentEnabled) {
    return null;
  }

  return (
    <div style={{ display: showCopilot ? 'block' : 'none' }}>
      {enableCopilot && (
        <AdsCopilotLoader
          key={key}
          {...props}
          isLiveAgentOnlyMode
          onClose={onClose}
          restartLiveAgentConversation={restartLiveAgentConversation}
        />
      )}
    </div>
  );
});
